<script>
export const group = 'Bottom'
export const reuseComponent = true
</script>

<script setup>
import { nextTick, onMounted, ref, watch } from 'vue'
import SlidingPill from './elements/SlidingPill.vue'
import JOEAppMessageIn from '../../../assets/animations/joe/joe_app_message_in.webm'
import JOEAppMessageOut from '../../../assets/animations/joe/joe_app_message_out.webm'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const displayMessage = ref(item.enrichment.message)

const showIn = ref(true)
const showOut = ref(false)
const videoIn = ref(null)
const videoOut = ref(null)

const imageElement = ref(null)
const cloudElement = ref(null)
const cloudTextElement = ref(null)
const cloudTriangleElement = ref(null)

const nameTimeline = ref(null)
const nameTimelineOut = ref(null)

const videoInResetAndPlay = () => {
  videoIn.value.currentTime = 0
  videoIn.value.play()
}

onMounted(() => {
  gsapTimeline({ name: 'AppMessageSmall' })
    .to({}, { onComplete: () => videoInResetAndPlay(), duration: 0 })
    .from(cloudElement, { scale: 0, duration: frames(25, 50), transformOrigin: 'bottom left', ease: 'back.out(1.7)' }, frames(20, 50))
    .from(cloudTriangleElement, { opacity: 0, yPercent: -100, duration: frames(10, 50), ease: 'power1.out' }, `<${frames(5, 50)}`)
    .add(nameTimeline, `<${frames(10, 50)}`)
})

const { onDisappear } = useDisappearable()
onDisappear(async () => {
  showOut.value = true
  showIn.value = false

  videoOut.value.play()

  await gsapTimeline({ name: 'AppMessageSmall - End', delay: frames(15, 50) })
    .to(imageElement, { scale: 0, rotate: 12, duration: frames(15, 50), transformOrigin: 'bottom left', ease: 'power3.in' })
    .to(cloudElement, { scale: 0, duration: frames(10, 50), transformOrigin: 'bottom left', ease: 'back.in(1.7)' }, `<`)
    .to(cloudTriangleElement, { opacity: 0, yPercent: -100, duration: frames(10, 50), ease: 'power1.in' }, `<`)
    .add(nameTimelineOut.value(), `<`)

  await new Promise((resolve) => videoOut.value.addEventListener('ended', resolve))
})

watch(
  () => item.enrichment.message,
  async (newMessage) => {
    await gsapTimeline({ name: 'AppMessageSmall - Update Out' })
      .add(nameTimelineOut.value())
      .to(imageElement, { scale: 0, rotate: 12, duration: frames(15, 50), transformOrigin: 'bottom left', ease: 'power3.in' }, `<`)
      .to(cloudElement, { scale: 0.4, duration: frames(25, 50), transformOrigin: 'bottom left', ease: 'back.out(1.7)' }, `<${frames(10, 50)}`)
      .to(cloudTextElement, { filter: 'blur(8px)', duration: frames(20, 50), ease: 'power1.out' }, `<`)

    displayMessage.value = newMessage

    await nextTick()

    await gsapTimeline({ name: 'AppMessageSmall - Update In' })
      .fromTo(cloudTextElement, { filter: 'blur(8px)' }, { filter: 'blur(0px)', duration: frames(10, 50), ease: 'power1.out' })
      .fromTo(cloudElement, { scale: 0.4 }, { scale: 1, duration: frames(25, 50), transformOrigin: 'bottom left', ease: 'back.out(1.7)' }, '<')
      .add(nameTimeline, `<${frames(10, 50)}`)
  }
)

const animateImageIn = () =>
  gsapTimeline({ name: 'AppMessageSmall - Image In' }).fromTo(
    imageElement,
    { scale: 0, rotate: -12 },
    { transformOrigin: 'bottom left', scale: 1, rotate: -3, duration: frames(30, 50), ease: 'power3.out' },
    `<`
  )
</script>

<template>
  <VideoPlayer v-show="showIn" class="absolute bottom-0 left-0" :src="JOEAppMessageIn" muted @videoElement="videoIn = $event" />
  <VideoPlayer v-show="showOut" class="absolute bottom-0 left-0" :src="JOEAppMessageOut" muted @videoElement="videoOut = $event" />
  <div class="w-112 absolute left-[140px] bottom-[275px]">
    <img
      v-if="displayMessage.image"
      ref="imageElement"
      :src="displayMessage.image"
      class="h-96 max-w-96 object-cover relative -rotate-3 border-[6px] border-white drop-shadow-2xl mb-8 ml-4 origin-bottom-left scale-0"
      @load="animateImageIn"
    />
    <SlidingPill :key="displayMessage.from.name" :text="displayMessage.from.name" class="mb-2" @timeline="nameTimeline = $event" @timelineOut="nameTimelineOut = $event" />
    <div v-if="displayMessage.message" ref="cloudElement" class="px-6 py-5 text-2xl font-semibold rounded-3xl bg-gradient-to-r from-joe-cr-blue-darker to-joe-cr-blue-primary text-white">
      <span ref="cloudTextElement">{{ displayMessage.message }}</span>
    </div>
    <div v-if="displayMessage.message" ref="cloudTriangleElement" class="bg-joe-cr-blue-darker w-5 h-6 -mt-1 ml-8" :style="{ clipPath: 'polygon(0% 0%, 100% 0%, 0% 100%, 0% 0%)' }" />
  </div>
</template>
